import { render, staticRenderFns } from "./SetAvatar.vue?vue&type=template&id=4bab29a1&"
import script from "./SetAvatar.vue?vue&type=script&lang=ts&"
export * from "./SetAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./SetAvatar.vue?vue&type=style&index=0&id=4bab29a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports